const mixinMenu = {
  methods: {
    /**
     * Método para seleccionar en el menu el elemento activo y resaltar
     * la seleccion visualmente
     * @param {String} hrefToSearch
     * @param {String} elementToSearch
     * @param {String} classTo
     */
    selectedItemOnMenu(
      hrefToSearch,
      elementToSearch = 'icon-left-menu',
      classTo = 'router-link-exact-active active'
    ) {
      setTimeout(() => {
        this.activeItem([elementToSearch, classTo, hrefToSearch]);
      }, 10);
    },

    /**
     * Método para desseleccionar en el menu el elemento que estaba activo
     * @param {*} hrefToSearch
     * @param {String} elementToSearch
     * @param {String} classTo
     */
    deselectedItemOnMenu(
      hrefToSearch,
      elementToSearch = 'icon-left-menu',
      classTo = ''
    ) {
      this.activeItem([elementToSearch, classTo, hrefToSearch]);
    },

    async activeItem(data) {
      let elementsArray = document.getElementsByClassName(data[0]);

      for (let key of elementsArray) {
        if (key.parentElement.href.includes(data[2])) {
          key.parentElement.className = 'nav-link ' + data[1];
          key.parentElement.parentElement.className = 'nav-item ' + data[1];

          if (
            key.parentElement.parentElement.parentElement.tagName.toLowerCase() ==
              'ul' &&
            key.parentElement.parentElement.parentElement.parentElement.tagName.toLowerCase() ==
              'div' &&
            key.parentElement.parentElement.parentElement.parentElement.parentElement.tagName.toLowerCase() ==
              'li'
          ) {
            key.parentElement.parentElement.parentElement.parentElement.parentElement.className =
              'nav-item custom-active-menu';
          }

          return true;
        }
      }

      return false;
    },

    /**
     * Verificar si el módulo esta activo en la lista de
     * módulos del usuario logeado
     * @param {*} moduleId
     * @returns
     */
    verifyModuleAuthorization(moduleId) {
      if (this.userModules.includes(moduleId)) {
        return true;
      }
      return false;
    },

    /**
     * Obtener los módulos de nivel 2 que estan activos en la lista de
     * módulos del usuario logeado
     * @param {Array} modules
     * @returns
     */
    getLevelTwoModules(modules) {
      let response = [];
      if (modules) {
        response = response.concat(
          modules.filter(
            (menuModule) =>
              menuModule.level == 2 &&
              this.verifyModuleAuthorization(menuModule.id)
          )
        );

        response = response.concat(
          modules.filter((menuModule) => {
            if (
              menuModule.level == 2 &&
              !this.verifyModuleAuthorization(menuModule.id)
            ) {
              menuModule.icon = menuModule.icon.replace('color', 'gray');
              menuModule.url = 'notaccess';

              return menuModule;
            }
          })
        );
      }

      return response;
    },
  },
};

export default mixinMenu;
